import { useAuth } from "../../context/AuthContext";
import { Button } from "../../components/common/Button";
import styles from "./LoginScreen.module.css";

export function LoginScreen() {
  const { login } = useAuth();
  return (
    <div className={styles.wrapper}>
      <div className={styles.card}>
        <div className={styles.logo} aria-hidden="true">🐝</div>
        <h1>Bee Keeper Admin</h1>
        <p>Internal operations console -- sign in with your admin account.</p>
        <Button onClick={login}>Sign In</Button>
        <p className={styles.notice}>
          This app is restricted to authorized administrators. Every sign-in and action is logged.
        </p>
      </div>
    </div>
  );
}
